import { Injectable } from "@angular/core";
import { BundleInfo } from "@shared/models/data-model";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { RegistrationApiService } from "./registration-api.service";

export type SoldoProductName = "GeneralSpending";

const PRODUCT_GENERAL_SPENDING: SoldoProductName = "GeneralSpending";
const PRODUCT_BY_PLAN: { [key: string]: SoldoProductName } = {
    SoldoStart: PRODUCT_GENERAL_SPENDING,
    SoldoPro: PRODUCT_GENERAL_SPENDING,
    Business: PRODUCT_GENERAL_SPENDING
};

@Injectable({
    providedIn: 'root'
})
export class BundleInfoService {
    private currentApplicationPlan: string;
    private currentApplicationOffer: string;
    private newApplicationPlan: string;
    private newApplicationOffer: string;
    private bundleList$: BehaviorSubject<BundleInfo[]>;

    constructor(
        private readonly registrationApiService: RegistrationApiService
    ) {}

    setCurrentApplicationPlan(plan: string) {
        this.currentApplicationPlan = plan;
    }

    setCurrentApplicationOffer(offer: string) {
        this.currentApplicationOffer = offer;
    }

    getCurrentApplicationPlan(): string {
        return this.currentApplicationPlan;
    }

    getCurrentApplicationOffer(): string {
        return this.currentApplicationOffer;
    }

    getCurrentApplicationProductName(): SoldoProductName {
        return PRODUCT_BY_PLAN[this.currentApplicationPlan];
    }

    setNewApplicationPlan(plan: string) {
        this.newApplicationPlan = plan;
    }

    setNewApplicationOffer(offer: string) {
        this.newApplicationOffer = offer;
    }

    getNewApplicationPlan(): string {
        return this.newApplicationPlan;
    }

    getNewApplicationOffer(): string {
        return this.newApplicationOffer;
    }

    getPlanOfferDescription(plan: string, offer: string): Observable<string> {
        let obs: Observable<BundleInfo[]>;
        if (this.bundleList$) {
            obs = this.bundleList$
        } else {
            obs = this.getPlanOfferList();
        }
        return obs.pipe(
                map(bundles => bundles.find(bundle => bundle.plan === plan && bundle.offer === offer)?.description)
            );
    }

    getPlanOfferList(): Observable<BundleInfo[]> {
        this.bundleList$ = new BehaviorSubject([]);
        return this.registrationApiService.getPlanOfferList()
            .pipe(
                tap(list => this.bundleList$.next(list))
            );
    }
}
